export enum ItemLabelDecorator {
    q_HD = "full-hd",
    q_4k = "ultra-hd"
}